export const SessionDataMap = {
  'cacheData.data.AriesReservation.brandCode': 'brandCode',
};
